var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"36","height":"44","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.122.5l28.925 18.93a3 3 0 0 1 0 5.021L5.122 43.381a3 3 0 0 1-4.643-2.51V3.012A3 3 0 0 1 5.122.5z","fill":_vm.fill,"fill-rule":"evenodd"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9bae86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-play.vue
// module id = null
// module chunks = 